import snakeCase from "lodash/snakeCase";

import { applyFilters, doRequest } from "./helpers";
import { DEFAULT_PAGE_SIZE } from "../constants/Constants";
import { isCustomTable } from "./customTableType";

export default class AuditService {
  static async getAuditLogs({
    modelId,
    modelType,
    slug,
    page = 1,
    perPage = DEFAULT_PAGE_SIZE,
    filters = {},
  }) {
    let path;
    if (isCustomTable(modelType)) {
      path =
        modelId != null
          ? `/audit_log/custom_table/${slug}/${modelId}`
          : `/audit_log/custom_table/${slug}`;
    } else {
      path = `/audit_log/${snakeCase(modelType)}/${modelId}`;
    }
    filters = {
      ...filters,
      page,
      per_page: perPage,
    };
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getAuditLogEntry({
    auditLogId,
    modelId,
    modelType,
    perPage = DEFAULT_PAGE_SIZE,
    filters = {},
  }) {
    modelType = isCustomTable(modelType)
      ? modelType.toLowerCase()
      : snakeCase(modelType);
    let path = `/audit_log/${auditLogId}`;
    filters = {
      ...filters,
      per_page: perPage,
      model_id: modelId,
      model_type: modelType,
    };
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getAuditLogFilterOptions({ modelType, slug }) {
    const filters = { model_type: modelType };
    if (isCustomTable(modelType)) {
      filters.slug = slug;
    }
    return doRequest("GET", applyFilters(filters, "/audit_log/filter_options"));
  }

  static async postManualLogEvent(data) {
    return doRequest("POST", `/audit_log/`, { data });
  }
}
